import request from '@/utils/request'


// 查询敏感词列表
export function listWord(query) {
  return request({
    url: '/sensitive/word/list',
    method: 'get',
    params: query
  })
}

// 查询敏感词分页
export function pageWord(query) {
  return request({
    url: '/sensitive/word/page',
    method: 'get',
    params: query
  })
}

// 查询敏感词详细
export function getWord(data) {
  return request({
    url: '/sensitive/word/detail',
    method: 'get',
    params: data
  })
}

// 新增敏感词
export function addWord(data) {
  return request({
    url: '/sensitive/word/add',
    method: 'post',
    data: data
  })
}

// 修改敏感词
export function updateWord(data) {
  return request({
    url: '/sensitive/word/edit',
    method: 'post',
    data: data
  })
}

// 删除敏感词
export function delWord(data) {
  return request({
    url: '/sensitive/word/delete',
    method: 'post',
    data: data
  })
}
